import { ReactNode, forwardRef } from 'react';

import classNames from 'classnames';

import { Text } from '@backstage/ui';

import styles from './SubtitleBui.module.css';

export interface SubtitleBuiProps {
  children: ReactNode;
  className?: string;
}

export const SubtitleBui = forwardRef<HTMLDivElement, SubtitleBuiProps>(
  ({ children, className }, ref) => {
    return (
      <Text
        variant="body-small"
        color="secondary"
        as="div"
        ref={ref}
        className={classNames(styles.root, className)}
      >
        {children}
      </Text>
    );
  },
);

SubtitleBui.displayName = 'DialogCompositeBui.Subtitle';

export default SubtitleBui;
